import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';

export const styles = StyleSheet.create({
  Wrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    padding: 10,
  },
});

export default {
  Text: styled.Text<{
    isFocused: boolean;
    activeColor: string;
    inactiveColor: string;
  }>`
    margin: 4px;
    color: ${({ isFocused, activeColor, inactiveColor }) =>
      isFocused ? activeColor : inactiveColor};
  `,
};
